import React from 'react';
import { ProDocWithAuthor } from '@dreamai/types';
import { ReactComponent as ProSheetIcon } from '../../icons/pro-sheet-icon.svg';
import { ReactComponent as ProDocIcon } from '../../icons/pro-doc-icon.svg';
import { ReactComponent as HeartOutlineIcon } from '../../icons/heart-outline.svg';
import { ReactComponent as HeartFilledIcon } from '../../icons/heart-filled.svg';

interface ProDocCardProps {
  doc: ProDocWithAuthor;
  onClick: (docId: string) => void;
  onFavoriteToggle?: (docId: string, isFavorited: boolean) => void;
}

const ProDocCard: React.FC<ProDocCardProps> = ({
  doc,
  onClick,
  onFavoriteToggle,
}) => {
  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onFavoriteToggle?.(doc.id, !doc.is_favorited);
  };

  return (
    <div
      className={`doc-card doc-card-${doc.type}`}
      onClick={() => onClick(doc.id)}
    >
      <div className='doc-icon'>
        {doc.type === 'sheet' ? <ProSheetIcon /> : <ProDocIcon />}
      </div>
      <div className='doc-card-header'>
        <h3>{doc.title}</h3>
        <p className='doc-updated'>
          Updated {new Date(doc.updated_at).toLocaleDateString()}
        </p>
      </div>

      <div className='doc-author'>
        {doc.author_image_url && (
          <div className='mini-mask'>
            <img src={doc.author_image_url} alt={doc.author_name || 'Author'} />
          </div>
        )}
        <span>from {doc.author_name}</span>
      </div>
      <div
        className={`favourite-changer ${doc.is_favorited ? 'active' : 'inactive'}`}
        onClick={handleFavoriteClick}
      >
        {doc.is_favorited ? <HeartFilledIcon /> : <HeartOutlineIcon />}
      </div>
    </div>
  );
};

export default ProDocCard;
